// extracted by mini-css-extract-plugin
export default {"post":"item_post__AQbhT","title":"item_title__68vFV","date":"item_date__v-si-","content":"item_content__Ib-tY"};